(function () {
  // Keep the sidebar nav positioned exactly below whatever is currently
  // pinned at the top (the sticky header — the top delivery bar and
  // announcement bar are NOT sticky and scroll away independently).
  //
  // Uses the header group's live getBoundingClientRect().bottom rather than
  // a one-time summed height, so the offset self-corrects as the page
  // scrolls, the top bar is dismissed, or bar heights change — instead of
  // leaving a stale gap once the non-sticky bars scroll out of view.
  var headerGroup = document.querySelector('.site-header-group');
  var sidebar = document.getElementById('sidebarNav');
  if (!sidebar) return;

  var ticking = false;

  function syncSidebarOffset() {
    ticking = false;
    var offset = 0;
    if (headerGroup) {
      var rect = headerGroup.getBoundingClientRect();
      // Never let it go negative (header scrolled fully out on non-sticky
      // layouts) — clamp to 0 so the sidebar doesn't get pushed above the
      // viewport.
      offset = Math.max(0, rect.bottom);
    }
    document.documentElement.style.setProperty('--sidebar-top-offset', offset + 'px');
  }

  function requestSync() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(syncSidebarOffset);
  }

  syncSidebarOffset();
  window.addEventListener('scroll', requestSync, { passive: true });
  window.addEventListener('resize', requestSync, { passive: true });
  window.addEventListener('load', syncSidebarOffset);
  setTimeout(syncSidebarOffset, 400);
  setTimeout(syncSidebarOffset, 1200);

  var closeBtn = document.getElementById('topFreeDeliveryClose');
  if (closeBtn) closeBtn.addEventListener('click', function () { setTimeout(syncSidebarOffset, 50); });
})();
